import React, { Component } from "react";
import { Navbar, Icon, NavItem, Dropdown, Divider } from 'react-materialize';
import M from 'materialize-css';
// import Header from "./components/Header";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Notary from "./components/NotaryPublic/notaryPublic";
import Services from "./components/Services/Services";
import Contacts from "./components/Contact/contacts";
import logo from "url:./assets/logo.png";
import Logo from "./components/Logo/Logo";
import { Link } from "react-scroll";
import "./modern.css";


const App = () => {
  return (
    <div>
      <div className="sticky nav-wrapper">
        <Navbar
          alignLinks="right"
          brand={<Logo className="logo-title" />}
          id="mobile-nav"
          menuIcon={<span className="menu-icon">≡</span>}
          options={{
            draggable: true,
            edge: 'left',
            inDuration: 250,
            onCloseEnd: null,
            onCloseStart: null,
            onOpenEnd: null,
            onOpenStart: null,
            outDuration: 200,
            preventScrolling: true
          }}
        >
          <Link id="sec-1" to="About" spy={true} activeClass="active" smooth={true} offset={-100} duration={500}>
            About
          </Link >
          <Link id="sec-2" to="notaryPublic" spy={true} activeClass="active" smooth={true} offset={-100} duration={500}>
            Notary Public
          </Link>
          <Link id="sec-3" to="services" spy={true} activeClass="active" smooth={true} offset={-100} duration={500}>
            Services
          </Link>
          <Link id="sec-4" to="Contacts" spy={true} activeClass="active" smooth={true} offset={-100} duration={500}>
            Contacts
          </Link>
        </Navbar>


      </div>

      <div className="container hero-wrap">
        <Home />
      </div>
      <section className="section-card"><About /></section>
      <section className="section-card"><Notary /></section>
      <section className="section-card"><Services /></section>
      <section className="section-card"><Contacts /></section>

      <footer className="page-footer ">
        <div className="container">
          <div className="row">
            <div className="col s12 m6 l6">
              <p className="white-text">Email: tiffanyboney@directsigningsservices.com</p>
              <p className="white-text">Phone: (862)231-4841</p>
            </div>
            <div className="col s12 m12 l12">
              <p className="grey-text text-darken-4 center text-bold">Disclaimer: State licensed notaries with Direct Signings Services do not practice law and may not give or accept fees for legal advice.</p>
            </div>
          </div>
        </div>
        <div className="center footer-copyright">
          <div className="container">
            <p className="copyright">© {new Date().getFullYear()} Direct Signings Services</p>

          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;